import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { QuestionSetConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';

@Component({
  selector: 'app-question-set-view',
  templateUrl: './question-set-view.component.html',
  styleUrls: ['./question-set-view.component.scss']
})
export class QuestionSetViewComponent {
  QuestionSetForm: FormGroup = this.formBuilder.group({});
  QuestionSetId:number =0;
  QuestionSetList:any=[];
  cancel:string=CommonConstant.CANCEL;
  CommonConstant:any=[];
  QuestionSetConstant:any=[];
  flag:boolean= false;

  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private apiUrl: ApiUrlHelper,
    public modalService: NgbActiveModal,
    private spinner:NgxSpinnerService
  ) { }

  ngOnInit(): void {
    this.spinner.show();
    this.CommonConstant = CommonConstant;
    this.QuestionSetConstant = QuestionSetConstant;
    this.getQuestionSetDetail(this.QuestionSetId);
  }
  
  get questionSetFormControl() {
    return this.QuestionSetForm.controls;
  }
  
  getQuestionSetDetail(QuestionSetId: number) { 
    const apiUrl = this.apiUrl.apiUrl.QuestionSet.GetQuestionSetById.replace("{id}", QuestionSetId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        this.QuestionSetList = data.data[0];
        this.spinner.hide();
        this.flag = true;
      },
      error: (err) => {
        console.log('getQuestionSetDetail-Error', err);
      }
    });
  }
}
